// Libs
import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useObserver } from "@shoothill/core";
import { Stores, StoresContext } from "Globals/Stores";
import { CustomInput } from "Globals/Styles/AppStyling";
import { StyledButton } from "Globals/Styles/ButtonStyles";
import { CustomTwoSelects } from "Globals/Styles/CustomTwoSelects";
import { Row } from "Globals/Styles/LayoutStyles";
import ApplicantViewModel from "Globals/ViewModels/ApplicantViewModel";
// View models
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import { CustomDatePicker } from "Globals/Views/CustomDatePicker";
import { CustomYesNoRadio } from "Globals/Views/CustomYesNoRadio";
import React, { useContext, useState } from "react";
// Styles
import styled from "styled-components";
import { FamilyAddressView } from "Views/Application/FormSections/PersonalDetails/FamilyAddressView";
import { PreviousAddressView } from "Views/Application/FormSections/PersonalDetails/PreviousAddressView";

export const StyledAddButton = styled(StyledButton)`
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    padding: 0px;
    margin: 0 0 1px 0;
`;

interface IProps {
    applicant: ApplicantViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const PersonalDetailsView: React.FC<IProps> = (props: IProps) => {
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(props.applicant.personalDetailsViewModel);

    const isPrimaryApplicant = (): boolean => {
        let applicants = props.applicationFormViewModel.applicantViewModels;
        let firstApplicant = applicants.find((a) => a.model.primaryApplicant);
        if (firstApplicant) {
            if (props.applicant.model.id == firstApplicant.model.id) return true;
        }

        return false;
    };

    return useObserver(() => (
        <div>
            {viewModel.DevTool_ShowCanProceed && <h5 style={{ color: "red" }}>Can Proceed: {viewModel.canProceed ? "Yes" : "No"}</h5>}

            {isPrimaryApplicant() === false && (
                <div>
                    <Row>
                        <CustomInput
                            type="select"
                            style={{ minWidth: "350px" }}
                            placeHolder={"placeHolder"}
                            label="Relationship to primary applicant"
                            viewModel={viewModel}
                            fieldName="relationshipTypeId"
                            selectItems={storesContext.Domain.RelationshipTypeStore.getRelationshipTypeOptions}
                            onChangeCallback={() => viewModel.restartTimer()}
                        />
                    </Row>
                </div>
            )}
            {/* Copy */}
            <Row>
                <Typography>Full name you will be purchasing in/corresponds with your passport</Typography>
            </Row>

            {/* Title */}
            <Row>
                <CustomInput
                    type="select"
                    style={isMobile ? { margin: "0" } : { minWidth: "350px" }}
                    label="Title"
                    viewModel={viewModel}
                    fieldName="title"
                    placeHolder={"Please select"}
                    className={"small"}
                    selectItems={storesContext.Domain.LookupStore.getSalutationOptions}
                    shrink={true}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
            </Row>

            {/* Firt middle last names */}
            <Row>
                <CustomInput
                    label="First name(s)"
                    placeHolder="Your first name(s)"
                    viewModel={viewModel}
                    fieldName="firstName"
                    shrink={true}
                    fullwidth={false}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
                <CustomInput
                    label="Middle name(s)"
                    placeHolder="Your middle name(s)"
                    viewModel={viewModel}
                    fieldName="middleName"
                    shrink={true}
                    fullwidth={false}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
                <CustomInput
                    label="Surname(s)"
                    placeHolder="Your last name(s)"
                    viewModel={viewModel}
                    fieldName="lastName"
                    shrink={true}
                    fullwidth={false}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
            </Row>
            {/* Date of birth */}
            <Row>
                <CustomDatePicker
                    viewModel={viewModel}
                    label="Date of birth"
                    placeholder={"date of birth"}
                    fieldName="dateOfBirth"
                    value={viewModel.model.dateOfBirth}
                    maxDate={new Date()}
                    onChange={(date: MaterialUiPickersDate) => {
                        viewModel.setDateOfBirth(date);
                        viewModel.handleInputChange();
                    }}
                    resetCallback={viewModel.restartTimer}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                />
            </Row>
            {/* Current Address */}
            <Row>
                <CustomInput
                    label="Current address line 1"
                    placeHolder="Address line 1"
                    viewModel={viewModel}
                    fieldName="addressLine1"
                    shrink={true}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                />
                <CustomInput
                    label="Current address line 2"
                    placeHolder="Address line 2"
                    viewModel={viewModel}
                    fieldName="addressLine2"
                    shrink={true}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                />
                <CustomInput
                    label="Current address line 3"
                    placeHolder="Address line 3"
                    viewModel={viewModel}
                    fieldName="addressLine3"
                    shrink={true}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                />
            </Row>
            <Row>
                <CustomInput
                    label="City/Town"
                    placeHolder="City/Town"
                    viewModel={viewModel}
                    fieldName="city"
                    shrink={true}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                />
                <CustomInput
                    label="Property county"
                    placeHolder="County"
                    viewModel={viewModel}
                    fieldName="county"
                    shrink={true}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                />
                <CustomInput
                    label="Postcode"
                    placeHolder="Postcode"
                    viewModel={viewModel}
                    fieldName="postcode"
                    shrink={true}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                />
            </Row>
            {/* How long have you lived section */}
            <Box style={{ backgroundColor: "#F0F0F0", padding: "15px", marginTop: "10px" }}>
                {/* Years/months */}
                <Row>
                    <CustomTwoSelects>
                        <CustomInput
                            id="first-select"
                            type="select"
                            viewModel={viewModel}
                            label="How long have you lived there?"
                            fieldName="yearsAtAddress"
                            placeHolder={"Please select"}
                            selectItems={storesContext.Domain.LookupStore.getYearOptions}
                            inputProps={{
                                disabled: props.applicationFormViewModel.model.isSubmitted,
                            }}
                            onChange={() => {
                                viewModel.handleInputChange();
                            }}
                        />
                        <CustomInput
                            type="select"
                            viewModel={viewModel}
                            fieldName="monthsAtAddress"
                            placeHolder={"Please select"}
                            selectItems={storesContext.Domain.LookupStore.getMonthOptions}
                            inputProps={{
                                disabled: props.applicationFormViewModel.model.isSubmitted,
                            }}
                            onChange={() => {
                                viewModel.handleInputChange();
                            }}
                        />
                    </CustomTwoSelects>
                </Row>
                {!(viewModel.model.yearsAtAddress >= 3) && (
                    <>
                        {/* Have you lived elsewhere */}
                        <Row>
                            <CustomYesNoRadio
                                label="Have you lived elsewhere in the last 3 years?"
                                fieldName={"livedElsewhereInLastThreeYears"}
                                value={viewModel.model.livedElsewhereInLastThreeYears}
                                onChange={viewModel.handleRadioChange}
                                disabled={props.applicationFormViewModel.model.isSubmitted}
                                error={viewModel.getError("livedElsewhereInLastThreeYears")}
                            />
                        </Row>
                        {/* Previous adress section */}
                        {viewModel.model.livedElsewhereInLastThreeYears && (
                            <PreviousAddressView applicationFormViewModel={props.applicationFormViewModel} personalDetailsViewModel={viewModel} />
                        )}
                    </>
                )}
            </Box>
            {/* Home/mobile phone and email address */}
            <Row>
                <CustomInput
                    label="Home telephone number (optional)"
                    placeHolder="Your telephone number"
                    viewModel={viewModel}
                    fieldName="homeTelephone"
                    shrink={true}
                    fullwidth={false}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
                <CustomInput
                    label="Mobile telephone number"
                    placeHolder="Your mobile number"
                    viewModel={viewModel}
                    fieldName="mobileTelephone"
                    shrink={true}
                    fullwidth={false}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
                <CustomInput
                    label="Email address"
                    placeHolder="john@smith.com"
                    viewModel={viewModel}
                    fieldName="email"
                    shrink={true}
                    fullwidth={false}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
            </Row>
            {/* Local authority are do you live in */}
            <Row>
                <CustomInput
                    style={isMobile ? { margin: "0" } : { minWidth: "350px" }}
                    type="select"
                    label="Which local authority area do you live in?"
                    placeHolder={"Please select"}
                    viewModel={viewModel}
                    fieldName="localAuthorityId"
                    shrink={true}
                    fullwidth={false}
                    selectItems={storesContext.Domain.LocalAuthorityStore.getLocalAuthorityOptions}
                    inputProps={{
                        disabled: props.applicationFormViewModel.model.isSubmitted,
                    }}
                    onChange={() => {
                        viewModel.handleInputChange();
                    }}
                />
            </Row>
            {/* Immediate family in local authority */}
            <Row>
                <CustomYesNoRadio
                    label="Do you have immediate family who live in the local authority area you are applying for?"
                    smallLabel="( Parents, siblings, spouses, children )"
                    fieldName={"immediateFamilyInLocalAuthority"}
                    value={viewModel.model.immediateFamilyInLocalAuthority}
                    onChange={viewModel.handleRadioChange}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                    error={viewModel.getError("immediateFamilyInLocalAuthority")}
                />
            </Row>
            {/* Family adress section */}
            {viewModel.model.immediateFamilyInLocalAuthority && (
                <Box style={{ backgroundColor: "#F0F0F0", padding: "15px" }}>
                    <Row>
                        <FamilyAddressView applicationFormViewModel={props.applicationFormViewModel} personalDetailsViewModel={viewModel} />
                    </Row>
                </Box>
            )}
            {/* Currently Employed */}
            <Row>
                <CustomYesNoRadio
                    label="Are you currently employed?"
                    fieldName={"employed"}
                    value={viewModel.model.employed}
                    onChange={viewModel.handleRadioChange}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                    error={viewModel.getError("employed")}
                />
                {viewModel.model.employed && (
                    <CustomInput
                        style={isMobile ? { margin: "0" } : { minWidth: "350px" }}
                        type="select"
                        label="Which local authority area do you work in?"
                        placeHolder={"Please select"}
                        viewModel={viewModel}
                        fieldName="workLocalAuthorityId"
                        shrink={true}
                        fullwidth={false}
                        selectItems={storesContext.Domain.LocalAuthorityStore.getLocalAuthorityOptions}
                        inputProps={{
                            disabled: props.applicationFormViewModel.model.isSubmitted,
                        }}
                        onChange={() => {
                            viewModel.handleInputChange();
                        }}
                    />
                )}
            </Row>
            {/* Ever owned a property */}
            <Row>
                <CustomYesNoRadio
                    label="Have you ever owned a property in the UK or abroad?"
                    fieldName={"hasOwnedPropertyInUKorAbroad"}
                    value={viewModel.model.hasOwnedPropertyInUKorAbroad}
                    onChange={viewModel.handleRadioChange}
                    disabled={props.applicationFormViewModel.model.isSubmitted}
                    error={viewModel.getError("hasOwnedPropertyInUKorAbroad")}
                />
            </Row>
        </div>
    ));
};
